
function Loading(){


    return(
        <div style={{width:"100vw",height:"100vh",background:"black" }} >
           
   <img style={{margin:"auto",justifyContent:"center",alignContent:"center"}}  src="https://blog.hubspot.com/hs-fs/hubfs/7a8f8d634013568124e130728834d47a.gif?width=1500&name=7a8f8d634013568124e130728834d47a.gif" />


           
        </div>
    )
}

export default Loading